module.exports = __webpack_public_path__ + "static/media/TicketBanner.3cb3a69e.svg";